import React from 'react';
import { orange, brown } from '@mui/material/colors';
import { Box } from '@mui/material';

import { Typography, WarningIcon } from '@occc/ui-design-system';

const FieldWarning: React.FC = () => {
  return (
    <Box
      display='flex'
      alignItems='flex-start'
      justifyContent='space-between'
      mb={2}
      p={2}
      bgcolor={orange[50]}
      color={brown[700]}
      border='1px solid'
      borderColor={orange[200]}
      borderRadius='4px'
      width='100%'
    >
      <WarningIcon />
      <Box px={2}>
        <Typography variant='subtitle1' paragraph>
          Heads Up!
        </Typography>
        <Typography>
          Members typically use either email or phone number to identify and engage with the
          program. Changing one of these values may impact a Members ability to log in or earn
          points. Please update with caution.
        </Typography>
      </Box>
    </Box>
  );
};

export default FieldWarning;
